/* Import External Modules */
import React from 'react';

/* Import Leverege Modules */
import { ns } from '@leverege/i18n';
import { Checkbox, Label, Pane, PropertyGrid, TextInput } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';

/* Import Local Modules */
import Model from "./BooleanFormatterModel.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = ns('ui-attributes.BooleanFormatterEditor');
/**
 * Editor for boolean formatter.
 * @param {Object} props.value - Value formatter object.
 * @param {String} props.value.type - Value type, e.g. attr.formatter.boolean.
 */
export default function BooleanFormatterEditor(props) {
  // Get parameters
  const {
    value
  } = props;
  const onModelChange = useValueChange(Model, props);

  // Validate parameters
  if (value == null) {
    return null;
  }
  const isOverrideChecked = Model.getOverrideValue(value) !== false;

  // Render editor
  return /*#__PURE__*/_jsxs(Pane, {
    style: {
      backgroundColor: 'var(--color-white)'
    },
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
      },
      label: t('overrideValue'),
      children: [/*#__PURE__*/_jsx(Checkbox, {
        eventData: "setOverrideValue",
        value: isOverrideChecked,
        onChange: onModelChange
      }), /*#__PURE__*/_jsx(Label, {
        variant: "input",
        children: t('overrideValue')
      })]
    }), isOverrideChecked && /*#__PURE__*/_jsxs(PropertyGrid, {
      style: {
        backgroundColor: 'var(--color-white)',
        border: 0
      },
      children: [/*#__PURE__*/_jsx(PropertyGrid.Item, {
        label: t('trueValue'),
        children: /*#__PURE__*/_jsx(TextInput, {
          size: 24,
          eventData: "setDisplayTrue",
          value: Model.getDisplayTrue(value),
          onChange: onModelChange
        })
      }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
        label: t('falseValue'),
        children: /*#__PURE__*/_jsx(TextInput, {
          size: 24,
          eventData: "setDisplayFalse",
          value: Model.getDisplayFalse(value),
          onChange: onModelChange
        })
      }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
        label: t('nullValue'),
        children: /*#__PURE__*/_jsx(TextInput, {
          size: 24,
          eventData: "setDisplayNull",
          value: Model.getDisplayNull(value),
          onChange: onModelChange
        })
      }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
        label: t('notSetValue'),
        children: /*#__PURE__*/_jsx(TextInput, {
          size: 24,
          eventData: "setDisplayUndefined",
          value: Model.getDisplayUndefined(value),
          onChange: onModelChange
        })
      })]
    })]
  });
}